import { useEffect } from 'react';

export default function SchemaMarkup() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://detetivepatrick.com.br';
    
    // Professional Service Schema
    const professionalServiceSchema = {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "Patrick Segers - Investigação Empresarial",
      "description": "Especialista em investigação empresarial oferecendo serviços de investigação defensiva, investigação de funcionários e investigação patrimonial",
      "url": siteUrl,
      "telephone": "+55-11-99370-6525",
      "email": "contato@detetivepatrick.com.br",
      "areaServed": {
        "@type": "Country",
        "name": "Brasil"
      },
      "serviceType": ["Investigação Defensiva", "Investigação de Funcionários", "Investigação Patrimonial"],
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          "opens": "08:00",
          "closes": "20:00"
        }
      ],
      "priceRange": "$$",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "BR"
      }
    };

    // Organization Schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Patrick Segers - Investigação Empresarial",
      "url": siteUrl,
      "logo": `${siteUrl}/logo.png`,
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+55-11-99370-6525",
        "contactType": "customer service",
        "email": "contato@detetivepatrick.com.br",
        "availableLanguage": "Portuguese"
      },
      "sameAs": [
        "https://wa.me/5511993706525"
      ]
    };

    // Website Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Patrick Segers - Investigação Empresarial",
      "url": siteUrl,
      "description": "Especialista em investigação empresarial: investigação defensiva, investigação de funcionários e investigação patrimonial",
      "publisher": {
        "@type": "Organization",
        "name": "Patrick Segers - Investigação Empresarial"
      }
    };

    // Service Schema for each service type
    const servicesSchema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "Service",
          "name": "Investigação Defensiva",
          "description": "Suporte direto a advogados e escritórios de advocacia com estratégia integrada com a defesa técnica",
          "provider": {
            "@type": "ProfessionalService",
            "name": "Patrick Segers - Investigação Empresarial"
          },
          "areaServed": "Brasil",
          "serviceType": "Investigação Defensiva"
        },
        {
          "@type": "Service",
          "name": "Investigação de Funcionários",
          "description": "Background checks completos e investigações imparciais de conduta profissional",
          "provider": {
            "@type": "ProfessionalService",
            "name": "Patrick Segers - Investigação Empresarial"
          },
          "areaServed": "Brasil",
          "serviceType": "Investigação de Funcionários"
        },
        {
          "@type": "Service",
          "name": "Investigação Patrimonial",
          "description": "Localização de ativos e verificação de antecedentes para processos legais",
          "provider": {
            "@type": "ProfessionalService",
            "name": "Patrick Segers - Investigação Empresarial"
          },
          "areaServed": "Brasil",
          "serviceType": "Investigação Patrimonial"
        }
      ]
    };

    // Insert schemas into head
    const schemas = [
      professionalServiceSchema,
      organizationSchema,
      websiteSchema,
      servicesSchema
    ];

    const scriptElements: HTMLScriptElement[] = [];

    schemas.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      script.id = `schema-markup-${index}`;
      document.head.appendChild(script);
      scriptElements.push(script);
    });

    // Cleanup function
    return () => {
      scriptElements.forEach(script => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, []);

  return null;
}
